import React from 'react';
import { MenuItem } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useContext } from "react"
import { QuoteContextStore } from '../../../../context/QuoteContext/QuoteContext';
import { ControlledTextField } from '../../../Core/Form/ControlledFields';
import { readableHullCoverage } from '../types';

const PhysicalDamageSelect = () => {
    const { aircrafts,coverages : { options } ,changeHullCoverage,locked_quote} = useContext(QuoteContextStore);
    
    if(!options) {
        return <Skeleton height={100} width={'100%'} />;
    }

    const { physical_damage_coverages } = options;
    const aircraft = aircrafts[Object.keys(aircrafts)[0]];
    return (
    <React.Fragment>
        <ControlledTextField 
        disabled = {!(aircraft.value > 0 ) ||locked_quote } fullWidth select name="physical_damage_coverage">
            <MenuItem selected disabled value="default" className="gray">
                <span className='gray'>{(aircraft.value > 0 ) ? 'Physical Damage' : 'Excluded'}</span>
            </MenuItem>
            {Object.keys(physical_damage_coverages).map(id => <MenuItem onClick={() => changeHullCoverage(id, physical_damage_coverages[id])} value={id} key={id}>{readableHullCoverage[physical_damage_coverages[id].label]}</MenuItem>)}
        </ControlledTextField>
    </React.Fragment>)
    
}

export default PhysicalDamageSelect;